'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Compare = require('acq-components/lib/composite-components/Compare/Compare');

var _reactRedux = require('react-redux');

var _compare = require('../../redux/selectors/compare');

var selectors = _interopRequireWildcard(_compare);

var _componentHelpers = require('../../utils/component-helpers');

var _ApplyModal = require('../ApplyModal/ApplyModal');

var _ApplyModal2 = _interopRequireDefault(_ApplyModal);

var _dtmEvent = require('acq-components/lib/utils/DTM/dtmEvent');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DTM_AddCard = 'AddCard';
var DTM_RemoveCard = 'RemoveCard';
var DTM_CloseCardPicker = 'CloseCardPicker';

var CompareWrapper = function CompareWrapper(_ref) {
  var styles = _ref.styles,
      props = (0, _objectWithoutProperties3.default)(_ref, ['styles']);

  var _useState = (0, _react.useState)({ show: false, cardName: '' }),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      modalState = _useState2[0],
      setModalState = _useState2[1];

  var openModal = function openModal(cardName) {
    return setModalState({ show: true, cardName: cardName });
  };
  var closeModal = function closeModal() {
    return setModalState({ show: false, cardName: '' });
  };
  var cards = props.cards;


  if (!cards || !cards.length || !props.labels || !props.labels.length) {
    return null;
  }
  cards.forEach(function (card) {
    var cardShortName = card.shortName;
    var modalButton = card.links.find(function (link) {
      return link.key === 'modal';
    });
    if (modalButton) {
      modalButton.onClick = function () {
        openModal(cardShortName);
      };
    }
    var links = card.links.find(function (link) {
      return link.key === 'termsAndConditions';
    });
    var dtm = card.TnCdtm;
    if (links) {
      links.onClick = function () {
        (0, _dtmEvent.triggerDTMEvent)({
          eventAction: dtm && dtm.eventAction,
          eventAsset: dtm && dtm.eventAsset
        });
      };
    }
  });
  var filteredCards = props.cards && props.cards.filter(function (card) {
    return card.dtmProductName === 'AmazonBusiness' || card.dtmProductName === 'AmazonBusinessPrime';
  });
  (0, _react.useEffect)(function () {
    var targetNode = document.querySelector('.compare');
    var config = {
      attributeFilter: ['class'],
      attributeOldValue: true,
      subtree: true
    };
    var allowedClassNames = ['amazon-business-tile', 'amazon-business-prime-tile', 'amazon-business-content', 'amazon-business-prime-content'];
    var callback = function callback(mutationList, observer) {
      mutationList.forEach(function (mutation) {
        switch (mutation.type) {
          case 'attributes':
            var mutatedCards = mutation.target.classList;
            var allowedCard = [].concat((0, _toConsumableArray3.default)(mutatedCards)).find(function (item) {
              return allowedClassNames.includes(item);
            });
            switch (allowedCard) {
              case 'amazon-business-tile':
                (0, _componentHelpers.attachListener)('.amazon-business-tile', filteredCards[0].TnCdtm.eventAsset, filteredCards[0].TnCdtm.eventAction);
                break;
              case 'amazon-business-prime-tile':
                (0, _componentHelpers.attachListener)('.amazon-business-prime-tile', filteredCards[1].TnCdtm.eventAsset, filteredCards[1].TnCdtm.eventAction);
                break;
              case 'amazon-business-content':
                (0, _componentHelpers.attachListener)('.amazon-business-content', filteredCards[0].TnCdtm.eventAsset, filteredCards[0].TnCdtm.eventAction);
                break;
              case 'amazon-business-prime-content':
                (0, _componentHelpers.attachListener)('.amazon-business-prime-content', filteredCards[1].TnCdtm.eventAsset, filteredCards[1].TnCdtm.eventAction);
                break;
            }
            break;
        }
      });
    };
    var observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
    return function () {
      (0, _componentHelpers.removeListener)('.amazon-business-tile');
      (0, _componentHelpers.removeListener)('.amazon-business-prime-tile');
      (0, _componentHelpers.removeListener)('.amazon-business-content');
      (0, _componentHelpers.removeListener)('.amazon-business-prime-content');
    };
  }, [props]);
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(_Compare.Compare, {
      cards: cards,
      labels: props.labels,
      annualFeeLabel: props.annualFeeLabel,
      cardPickerDismissDtm: (0, _componentHelpers.createClickDtmObj)(DTM_CloseCardPicker),
      addCardDtm: (0, _componentHelpers.createClickDtmObj)(DTM_AddCard),
      namespace: 'compare',
      isFullWidthBackgroundMode: true,
      cardPickerHeaderText: props.cardPickerHeaderText,
      addCardText: props.addCardText,
      styles: {
        cardPickerStyles: styles.cardPicker,
        compareStyles: styles.compare,
        compareListStyles: styles.compareList,
        compareStickyBarStyles: styles.compareStickyBar
      },
      preFilledCards: props.preFilledCards
    }),
    modalState.show && _react2.default.createElement(_ApplyModal2.default, {
      styles: styles,
      cardName: modalState.cardName,
      closeModal: closeModal,
      dtmHelper: props.dtmHelper
    })
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    cards: selectors.getCards(state),
    labels: selectors.getLabels(state),
    annualFeeLabel: selectors.getAnnualFeeLabel(state),
    cardPickerHeaderText: selectors.getCardPickerHeaderText(state),
    addCardText: selectors.getAddCardText(state),
    preFilledCards: selectors.getPreFilledCards(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CompareWrapper);